import { render } from "./CheckboxSingleInput.vue?vue&type=template&id=50c2f72b&scoped=true"
import script from "./CheckboxSingleInput.vue?vue&type=script&lang=js"
export * from "./CheckboxSingleInput.vue?vue&type=script&lang=js"

import "./CheckboxSingleInput.vue?vue&type=style&index=0&id=50c2f72b&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c2f72b"]])

export default __exports__